import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Helpers } from '../../../helpers';
import { ScriptLoaderService } from '../../../_services/script-loader.service';


@Component({
    selector: ".m-grid__item.m-grid__item--fluid.m-grid.m-grid--hor-desktop.m-grid--desktop.m-body",
    templateUrl: "./default.component.html",
    encapsulation: ViewEncapsulation.None,
})

/*@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styles: []
})*/
export class DefaultComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
